<div class="card mb-3">
    <div class="card-header d-flex flex-row justify-content-between">
        <h2 class="card-title mb-0">4D Bet History</h2>
        <span class="badge bg-secondary align-self-center">4DKING (Transfer Wallet)</span>
    </div>
    <div class="p-3">
        <div class="row g-2 align-items-end mb-2">
            <div class="col-12 col-sm-6 col-md-auto">
                <label class="form-label">Date From</label>
                <input type="datetime-local" class="form-control" [(ngModel)]="data.date_from" />
            </div>
            <div class="col-12 col-sm-6 col-md-auto">
                <label class="form-label">Date To</label>
                <input type="datetime-local" class="form-control" [(ngModel)]="data.date_to" />
            </div>
            <div class="col-12 col-sm-6 col-md-auto">
                <label class="form-label">Player Code</label>
                <input type="text" class="form-control" [(ngModel)]="data.code" />
            </div>
            <div class="col-12 col-sm-6 col-md-auto">
                <label class="form-label">Player Mobile</label>
                <input type="text" class="form-control" [(ngModel)]="data.mobile" placeholder="Include Country Code" />
            </div>
            <div class="col-12 col-sm-6 col-md-auto">
                <label class="form-label">4DKING Username</label>
                <input type="text" class="form-control" [(ngModel)]="data.username" />
            </div>
            <div class="col-6 col-sm-4 col-md-auto">
                <label class="form-label">Match</label>
                <select class="form-select" [(ngModel)]="data.match">
                    <option value="exact">Exact</option>
                    <option value="approx">Approximate</option>
                </select>
            </div>
            <div class="col-12 col-md-auto">
                <button class="btn btn-primary w-100" (click)="filter()">Filter</button>
            </div>
        </div>
        <p class="text-muted small mb-0">
            Net = Win − Stake. 4DKING keeps only the last 14 days of records; older bets are pulled by the scheduled sync.
        </p>
    </div>
</div>

<div class="mb-3 card" *ngIf="!load && items.length > 0">
    <div class="card-body p-3 d-flex flex-row flex-wrap gap-3 align-items-center">
        <div class="card"><div class="card-body"><p class="mb-0"><b>Total Record:</b> {{page_nat.total ?? 0}}</p></div></div>
        <div class="card"><div class="card-body"><p class="mb-0"><b>Total Stake:</b> {{summary.total_stake ?? 0 | number:'1.2-2'}}</p></div></div>
        <div class="card"><div class="card-body"><p class="mb-0"><b>Total Win:</b> {{summary.total_win ?? 0 | number:'1.2-2'}}</p></div></div>
        <div class="card"><div class="card-body"><p class="mb-0"><b>Total Net:</b> {{summary.total_winloss ?? 0 | number:'1.2-2'}}</p></div></div>
        <nav>
            <ul class="pagination mb-0">
                <li class="page-item"><a class="page-link" (click)="filter(page_nat.current_page - 1)" *ngIf="page_nat.current_page - 1 >= 1">&lt;</a></li>
                <li class="d-flex flex-row align-items-center px-2">Page {{page_nat.current_page}} / {{page_nat.total_page}}</li>
                <li class="page-item"><a class="page-link" (click)="filter(page_nat.current_page + 1)" *ngIf="page_nat.current_page + 1 <= page_nat.total_page">&gt;</a></li>
            </ul>
        </nav>
    </div>
</div>

<div class="card">
    <div class="card-body p-0">
        <ng-container *ngIf="!load && items.length == 0">
            <h3 class="mb-0 px-2 py-2">No Data Available</h3>
        </ng-container>

        <ng-container *ngIf="load">
            <div class="d-flex flex-row align-items-center justify-content-center p-2">
                <div class="loader"></div>
            </div>
        </ng-container>

        <div *ngIf="!load && items.length > 0" style="overflow-x: auto;">
            <table class="table table-sm table-striped mb-0" style="font-size: 11px;">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Player</th>
                        <th>Mobile</th>
                        <th>4DKING User</th>
                        <th>Product</th>
                        <th>Number</th>
                        <th>Option</th>
                        <th class="text-end">Big</th>
                        <th class="text-end">Small</th>
                        <th class="text-end">4A</th>
                        <th class="text-end">3A</th>
                        <th class="text-end">3C</th>
                        <th class="border-start bg-primary text-light text-end">Stake</th>
                        <th class="border-start bg-success text-light text-end">Win</th>
                        <th class="border-start text-end">Net</th>
                        <th>Ticket Ref</th>
                        <th>Draw Date</th>
                        <th>Bet Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of items; let i = index;">
                        <td>{{((page_nat.current_page ?? 1) - 1) * (page_nat.per_page ?? 200) + (i + 1)}}</td>
                        <td>{{item.player_code || '--'}}</td>
                        <td>{{item.player_mobile || '--'}}</td>
                        <td>{{item.username}}</td>
                        <td>{{item.product_name || item.product_code}}</td>
                        <td>{{item.number}}</td>
                        <td>{{item.bet_option || '--'}}</td>
                        <td class="text-end">{{item.big | number:'1.2-2'}}</td>
                        <td class="text-end">{{item.small | number:'1.2-2'}}</td>
                        <td class="text-end">{{item.a4 | number:'1.2-2'}}</td>
                        <td class="text-end">{{item.a3 | number:'1.2-2'}}</td>
                        <td class="text-end">{{item.a3c | number:'1.2-2'}}</td>
                        <td class="border-start bg-primary text-light text-end">{{item.stake | number:'1.2-2'}}</td>
                        <td class="border-start text-end" [class.bg-success]="item.win > 0" [class.text-light]="item.win > 0">{{item.win | number:'1.2-2'}}</td>
                        <td class="border-start text-end" [class.text-success]="item.winloss > 0" [class.text-danger]="item.winloss < 0">{{item.winloss | number:'1.2-2'}}</td>
                        <td style="font-size: 9px;">{{item.tix_ref_no}}</td>
                        <td>{{item.draw_date | date: "dd-MM-yyyy"}}</td>
                        <td>{{item.bet_date | date: "dd-MM-yyyy HH:mm:ss"}}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="12" class="text-end">Total</td>
                        <td class="text-end">{{sum('stake') | number:'1.2-2'}}</td>
                        <td class="text-end">{{sum('win') | number:'1.2-2'}}</td>
                        <td class="text-end">{{sum('winloss') | number:'1.2-2'}}</td>
                        <td colspan="3"></td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</div>
